module.exports = __webpack_public_path__ + "static/media/materi.ff29dcb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/materi.png
// module id = 1611
// module chunks = 0